import type { FormSheetItems } from "../../core/components/FormDataModal";
import type { IconProp } from "../../ui/icons";
import type BusinessModuleModel from "./BusinessModuleModel";
import type { BusinessModuleModelData, Snapshot } from "./BusinessModuleModel";

export enum BusinessModuleType {
  Reminder = "reminder",
  Info = "info",
}

export enum BusinessModuleState {
  Planning = "planning",
  Done = "done",
  Locked = "locked",
  Archived = "archived",
}

export type BusinessCreateModule = {
  type: BusinessModuleType;
  title: string;
  emoji: string;
};

export type BusinessModuleMetaData = {
  type: BusinessModuleType;
  title: string;
  emoji: string;
  description: string;

  extraData?: FormSheetItems;
  // biome-ignore lint/suspicious/noExplicitAny: Because
  formValues?: { [key: string]: any };
  // biome-ignore lint/suspicious/noExplicitAny: Because
  prepareData?: (inData: any) => any;
};

export type BusinessModuleMetaCategory = {
  title?: string;
  icon?: IconProp;
  modules: BusinessModuleMetaData[];
};

export type BusinessGenericModel = BusinessModuleModel<
  Snapshot,
  BusinessModuleModelData<Snapshot>
>;
